const invertedMessages = {
  'Failed to read metadata file': 'Auth.ErrorState.MetadataFileReadError',
  'Failed to load metadata file': 'Auth.ErrorState.MetadataFileLoadError',
  'Alias already exists': 'Auth.ErrorState.duplicateAlias',
  'Display Name already exists': 'Auth.ErrorState.duplicateDisplayName',
  'Up to {count} lower-case alphaneumeric characters are allowed.':
    'Auth.ErrorState.IDP.maxAlias',
  'Up to {count} alphaneumeric and space characters are allowed.':
    'Auth.ErrorState.IDP.maxDisplayName',
  'No EntityDescriptor found in file.':
    'Auth.ErrorState.MetadataFile.noEntityDescriptor',
  'No IDPSSODescriptor found in file.':
    'Auth.ErrorState.MetadataFile.noIDPSSODescriptor',
  'No NameIDFormat found in file.':
    'Auth.ErrorState.MetadataFile.noNameIDFormat',
  'Error parsing file: {error}': 'Auth.ErrorState.MetadataFile.parseError',
  'An error occurred while loading your configurations. Please refresh this page to try again.':
    'Auth.ErrorState.SSOConfigurationLoadError',
  'An error occurred while saving your configurations. Please try again.':
    'Auth.ErrorState.SSOConfigurationSaveError',
  'Key name can be up to 32 alphaneumeric and underscore characters only':
    'Auth.ErrorState.KeyNameValidation',
  'Key name must be unique': 'Auth.ErrorState.KeyNameUnique',
  'Private key does not match expected format':
    'Auth.ErrorState.PrivateKeyFormat',
  'Certificate does not match expected format':
    'Auth.ErrorState.CertificateFormat',
  'An error occurred while activating the key. Please try again.':
    'Auth.ErrorState.KeyActivationError',
  'An error occurred while deleting the key. Please try again.':
    'Auth.ErrorState.KeyDeletionError',
  'An error occurred while loading your SSO keys. Please refresh this page to try again.':
    'Auth.ErrorState.SSOKeysLoadError',
  'An error occurred while adding the key. Please try again.':
    'Auth.ErrorState.KeyAdditionError',
  'Something went wrong. Please try again later.':
    'Auth.ErrorState.somethingWentWrong',
  'Unknown Provider': 'Auth.ErrorState.unknownProvider',
  'Failed to delete client. Please try again.':
    'Auth.ErrorState.ClientDeletionError',
  'Please enter a valid URL': 'Auth.ErrorState.InvalidUrl',
};

export default invertedMessages;
